(ns common.widgets.error-boundary
  (:require ["@mui/material/Accordion$default" :as Accordion]
            ["@mui/material/AccordionDetails$default" :as AccordionDetails]
            ["@mui/material/AccordionSummary$default" :as AccordionSummary]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [->clj]]
            [cljs.pprint]
            [common.error-page.view :refer [error-page]]
            [common.url-template :as url-tpl]
            [common.widgets.panel :as panel]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui uncaught-error-view [{:keys [error set-error]}]
  (let [url-context (use-subscribe [:url-context])]
    ($ panel/panel
       {:title "An error occurred"
        :sx #js {:mx 1}}
       ($ Stack
          {:spacing 2}
          ($ :p "While loading the page an error occurred.")
          ($ :p "Please reach out to our "
             ($ Link
                {:rel "noopener noreferrer"
                 :color "primary"
                 :target "_blank"
                 :href (url-tpl/render :docs/support url-context)}
                "support desk") ".")
          ($ :div
             ($ Accordion
                {:elevation 0
                 :sx #js {:borderWidth 1
                          :borderColor "grey.70"
                          :borderStyle "solid"}}
                ($ AccordionSummary
                   {:expandIcon ($ Icon "expand_more")}
                   "Click here for more information")
                ($ AccordionDetails {:sx #js {:backgroundColor "grey.70"}}
                   ($ Typography {:component "pre"
                                  :fontSize "caption.fontSize"
                                  :fontFamily "monospace"
                                  :tabIndex -1
                                  :sx #js {:userSelect "all"
                                           :maxHeight "24rem"
                                           :overflowY "auto"}}
                      (with-out-str (cljs.pprint/pprint error))))))
          ($ Button
             {:variant "contained"
              :onClick #(set-error nil)
              :sx #js {:alignSelf "flex-start"}}
             "Try again")))))

(def status->code
  {404 "not_found_error"
   401 "not_authorized_error"})

(def error-boundary
  (uix/create-class
   {:displayName "error-boundary"
    :getInitialState (fn [] #js {:error nil})
    :getDerivedStateFromError (fn [error] #js {:error error})
    :componentDidCatch (fn [error _error-info]
                         (this-as ^js this
                                  (let [props (.. this -props -argv)]
                                    (when-let [on-error (:on-error props)]
                                      (on-error error)))))
    :render (fn []
              (this-as ^js this
                       (if-let [error (->clj (.. this -state -error))]
                         (let [data (-> (:data error)
                                        (cond-> (string? (:data error)) js/JSON.parse)
                                        ->clj)]
                           (case (:status error)
                             (401 404)
                             ($ error-page
                                {:code (get status->code (:status error))
                                 :error-message (get-in data [:error :message])})
                             ($ uncaught-error-view
                                {:error error
                                 :set-error #(.. this (setState #js {:error %}))})))
                         (.. this -props -children))))}))
